import  { useEffect, useMemo, useRef } from 'react';
import {createPortal} from 'react-dom'


/**
 * 
 * Its is bascially used to create a portal at the top most level in the body element
 * 1. if id of element is provided then it will inject the children inside that element
 *    else it will create a new div element with id = `hiver_modal` and inject the children inside it. 
 * 
 * 2. Basically used for creating Portals outside of current flow
 */

let curr_id = 1;

export function InsertInDom({id, children}){

    const modalElem = useRef(null);
    useEffect(() => {
        return () => {
            //  clearing the newly created dom element on unmount, if exists
            if(modalElem.current){
                document.body.removeChild(modalElem.current);
            }
        }
    }, [])

    const container = useMemo(() => {
         const elem = id ? document.getElementById(id) : '';
         if(elem){
             return elem;
         }

         // creating the new element to inject in body
         const divElem = document.createElement('div');
         divElem.setAttribute('id', `hiver_modal_${curr_id}`);
         curr_id++;
         modalElem.current = divElem;
         document.body.appendChild(divElem);
         return divElem;
    }, [id])

    return createPortal(children,container);
}